import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    attrs: {
      "data-sign": "logistics_agent_abnormal_detail_modal",
      "title": _vm.t('异常详情')
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.t('预报箱数')) + " "), _c('span', {
    staticClass: "num-text"
  }, [_vm._v(_vm._s(_vm.detaildata.forecast_box_num))]), _vm._v(" " + _vm._s(_vm.tc('箱')) + _vm._s(_vm.tc('，')) + _vm._s(_vm.t('异常')) + " "), _c('span', {
    staticClass: "num-text"
  }, [_vm._v(_vm._s(_vm.detaildata.exception_box_num))]), _vm._v(_vm._s(_vm.tc('箱')) + " ")]), _c('my-table', {
    attrs: {
      "columns": _vm.columns,
      "bordered": "",
      "data-sign": "logistics_agent_abnormal_detail_box_list",
      "data-source": _vm.detaildata.box_list
    }
  })], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": function ($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))])], 1)]);
};

var staticRenderFns = [];
export { render, staticRenderFns };